import { createContext, useContext } from 'react'

import type { SelectOption } from '../types'

export type SelectionContextValue = {
  selectedValues: string[]
  selectedOptions: SelectOption[]
  handleSelect: (optionValue: string) => void
  handleSelectAll: () => void
  handleGroupSelect?: (group: SelectOption) => void
  clearSelection: () => void
  selectAllState: {
    checked: boolean
    indeterminate: boolean
  }
}

export const SelectionContext = createContext<SelectionContextValue | undefined>(undefined)

export const useSelectionContext = () => {
  const context = useContext(SelectionContext)
  if (!context)
    throw new Error('useSelectionContext must be used within a SelectionContext.Provider')
  return context
}
